import React from "react";

// Sentry "App-icon Shield" logo (page 4, Concept A) — rounded-square orange badge
// with a white shield containing a white checkmark. Wordmark "Sentry" + tagline.
export function LogoMark({ size = 40 }) {
  return (
    <div
      data-testid="sentry-logo-mark"
      style={{ width: size, height: size }}
      className="rounded-[10px] bg-[#FF6B35] flex items-center justify-center shrink-0 shadow-sm"
    >
      <svg width={size * 0.6} height={size * 0.6} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2L4 5v6c0 5 3.4 9.4 8 11 4.6-1.6 8-6 8-11V5l-8-3z" fill="#FFFFFF"/>
        <path d="M8.5 12.2l2.4 2.4 4.6-4.6" stroke="#FF6B35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  );
}

export default function Logo({ variant = "light", showTagline = true }) {
  const isDark = variant === "dark";
  return (
    <a href="/" data-testid="brand-logo" className="inline-flex items-center gap-3 group">
      <LogoMark size={40} />
      <div className="leading-tight">
        <div className={`font-display text-[22px] font-bold ${isDark ? "text-cream" : "text-navy"}`}>Sentry</div>
        {showTagline && (
          <div className={`eyebrow ${isDark ? "text-cream/60" : "ink"}`} style={{ fontSize: 10 }}>
            Lunar Occultation
          </div>
        )}
      </div>
    </a>
  );
}
